import React from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { setUsuario }  from './actions';
import Registro from './sys/registro';
import PostulacionRecibida from './sys/registro/postulacion-recibida';


function mapDispatchToProps(dispatch) {
  return {
    setUsuario: usuario => dispatch(setUsuario(usuario))
  }
}

function App(props) {
  const [cookies] = useCookies(['nombre', 'urlImagen', 'token']);
  props.setUsuario({
      nombre: cookies['nombre'],
      urlImagen: cookies['urlImagen'],
  });

  return  (
          <Routes>
            <Route path="/" element={<Navigate to="/registro" />}/>
            <Route path="/registro" element={<Registro/>}/>
            <Route path="/postulacion-recibida" element={<PostulacionRecibida/>}/>
          </Routes> );
};

export default connect(null, mapDispatchToProps)(App);
